import { removeUndefineds } from '..'
import { getResolution } from '../../state/settings/renderDimensions'

export default function generateConnectionOptions(settings) {
    // See: https://media.twiliocdn.com/sdk/js/video/releases/2.0.0/docs/global.html#ConnectOptions
    // for available connection options.
    const connectionOptions = {
        // Bandwidth Profile, Dominant Speaker, and Network Quality
        // features are only available in Small Group or Group Rooms.
        // Please set "Room Type" to "Group" or "Small Group" in your
        // Twilio Console: https://www.twilio.com/console/video/configure
        bandwidthProfile: {
            video: {
                mode: settings.bandwidthProfileMode,
                dominantSpeakerPriority: settings.dominantSpeakerPriority,
                trackSwitchOffMode: settings.trackSwitchOffMode,
                // renderDimensions: {
                //     low: getResolution('cif'),
                //     standard: getResolution('vga'),
                //     high: getResolution('HD'),
                // },
                // maxTracks: Number(settings.maxTracks),
                clientTrackSwitchOffControl: 'manual',
                contentPreferencesMode: 'auto',
            },
        },
        dominantSpeaker: true,
        networkQuality: { local: 1, remote: 1 },
        // Comment this line if you are playing music.
        maxAudioBitrate: Number(settings.maxAudioBitrate),

        video: { ...settings.video },
        maxVideoBitrate: Number(settings.maxVideoBitrate),

        // VP8 simulcast enables the media server in a Small Group or Group Room
        // to adapt your encoded video quality for each RemoteParticipant based on
        // their individual bandwidth constraints. This has no effect if you are
        // using Peer-to-Peer Rooms.
        preferredVideoCodecs: [{ codec: 'VP8', simulcast: false }],
        // logLevel: 'debug',
        chromeSpecificConstraints: {
            optional: [
                // Enable CPU overuse detection
                { googCpuOveruseDetection: true },
                { googCpuOveruseEncodeUsage: true },
                { googCpuUnderuseThreshold: 55 },
                // The CPU % threshold for overuse
                { googCpuOveruseThreshold: 85 },
            ],
        },
    }

    // For mobile browsers, limit the maximum incoming video bitrate to 2.5 Mbps.
    // if (isMobile && connectionOptions.bandwidthProfile.video) {
    //   connectionOptions!.bandwidthProfile!.video!.maxSubscriptionBitrate = 2500000;
    // }

    // Here we remove any 'undefined' values. The twilio-video SDK will only use defaults
    // when no value is passed for an option. It will throw an error when 'undefined' is passed.
    return removeUndefineds(connectionOptions)
}
